var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order"
  }, [(_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [(_vm.displayMsg == 'success') ? _c('b-alert', {
    staticClass: "success-display-none",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.displayMsg == 'error') ? _c('b-alert', {
    staticClass: "danger-display-none",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(_vm.successErrorMsg) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')))]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "32px",
      "border-color": "#799497 !important"
    },
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    ref: "mrch_id",
    staticClass: "form-control",
    staticStyle: {
      "color": "rgb(20, 33, 44)",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "id": "mrch_id",
      "options": _vm.listMerchantData1,
      "selected-option": _vm.item,
      "placeholder": _vm.$t('common.merchantPlaceholder')
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1), _vm._v(" "), (_vm.slaflag) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sla.sla')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSLA),
      expression: "searchSLA"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchSLA"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSLA = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.selectSLA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Within SLA"
    }
  }, [_vm._v("Within SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Near SLA"
    }
  }, [_vm._v("Near SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SLA Breached"
    }
  }, [_vm._v("SLA Breached")])])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderNumber')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "orderid",
      "placeholder": _vm.$t('orders.orderNumberPlaceHolder')
    },
    model: {
      value: (_vm.orderid),
      callback: function($$v) {
        _vm.orderid = $$v
      },
      expression: "orderid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.multiOrder')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderclass),
      expression: "orderclass"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "orderclass"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.orderclass = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.showZone]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('orders.selectMultiOrder')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "multi"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')) + " ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "single"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.no')) + " ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.FromDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFlt),
      callback: function($$v) {
        _vm.fromDateFlt = $$v
      },
      expression: "fromDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.fromDateFlt == null || _vm.fromDateFlt == '') ? _c('span', {
    staticClass: "tselectPickerext-danger"
  }, [_vm._v(_vm._s(_vm.fromDateErr))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.toDate')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFlt),
      callback: function($$v) {
        _vm.toDateFlt = $$v
      },
      expression: "toDateFlt"
    }
  })], 1), _vm._v(" "), (_vm.toDateFlt == null || _vm.toDateFlt == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.toDateErr))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchchannel),
      expression: "searchchannel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchchannel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchchannel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.salesChannelPlaceHolder')))]), _vm._v(" "), _vm._l((_vm.channellist), function(channel) {
    return _c('option', {
      domProps: {
        "value": channel.saleschannel
      }
    }, [_vm._v("\n                          " + _vm._s(channel.saleschannel))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.fromShipDate')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm A",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.fromDateFltShip),
      callback: function($$v) {
        _vm.fromDateFltShip = $$v
      },
      expression: "fromDateFltShip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('orders.toShipDate')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm A",
      "placeholder": _vm.$t('common.datePlaceholder')
    },
    model: {
      value: (_vm.toDateFltShip),
      callback: function($$v) {
        _vm.toDateFltShip = $$v
      },
      expression: "toDateFltShip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block !important",
      "margin-top": "30px",
      "width": "16px"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "display": "inline-block",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "type": "checkbox",
      "id": "only_btoborder1",
      "name": "only_btoborder1"
    },
    on: {
      "change": function($event) {
        _vm.btoborder($event)
      }
    },
    model: {
      value: (_vm.only_btoborder),
      callback: function($$v) {
        _vm.only_btoborder = $$v
      },
      expression: "only_btoborder"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px",
      "color": "green !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "only_btoborder1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('orders.isB2BOrder')) + "?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.selectSelfshipStatus')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchselfship),
      expression: "searchselfship"
    }],
    staticClass: "form-control ",
    attrs: {
      "name": "searchselfship"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchselfship = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.all')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('boxList.selfShipped')) + " ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('orders.nonSelfShipped')) + " ")])])])], 1)], 1), _vm._v(" "), (_vm.zone) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.zone')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchzone),
      expression: "searchzone"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchzone"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchzone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zonePlaceHolder')))]), _vm._v(" "), _vm._l((_vm.listZoneData), function(zone_obj) {
    return _c('option', {
      domProps: {
        "value": zone_obj.zonename
      }
    }, [_vm._v(_vm._s(zone_obj.zonename))])
  })], 2)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetOrderSerach
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row expand",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-6 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('orders.pickerAssignment')) + " ")])]), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader s1 o3 "
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e(), _vm._v(" "), (_vm.listOrdersData.length > 0 && _vm.orderids != '') ? _c('div', {
    staticClass: "col-md-4 s1 o4 ",
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.listOrdersData.length > 0 && _vm.orderids != '') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pickerAssignmentShow = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow fa-lg"
  }), _vm._v(" " + _vm._s(_vm.$t('common.assignToPicker')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardreporttablerow",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "bind-title": "Select All"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.checkallflag == false
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "change": _vm.selectAllCheckbox,
      "__c": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.orderNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.salesChannel')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pincodemapping.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalSKU')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.totalQTY')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.ordercode')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.shipmentId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('orders.shipByDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('merchant.merchantName')))])]), _vm._v(" "), (_vm.slaflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('sla.sla')))])]) : _vm._e(), _vm._v(" "), (_vm.clientid == 1025) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Split Shipment")])]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.clientid == '') ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.selectClientFilter')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.OderqtyPlaceHolder')))])]) : _vm._e(), _vm._v(" "), (_vm.resultCount == 0 && _vm.client != '' && _vm.searchFlag == true) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.oderNotFoundErrSelectFilter')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listOrdersData), function(data) {
    return _c('tr', {
      staticClass: "text-center "
    }, [_c('td', [(data.totalquantity == 1) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.orderids),
        expression: "orderids"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": data.allowpicking == 0
      },
      domProps: {
        "value": data.orderid,
        "checked": Array.isArray(_vm.orderids) ? _vm._i(_vm.orderids, data.orderid) > -1 : (_vm.orderids)
      },
      on: {
        "change": function($event) {
          _vm.resetAll(data)
        },
        "__c": function($event) {
          var $$a = _vm.orderids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.orderid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.orderids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.orderids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.orderids = $$c
          }
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.orderids),
        expression: "orderids"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": data.defaultVal == 0 && data.totalquantity > 1 && data.issplited == 0 && _vm.clientid == 1025
      },
      domProps: {
        "value": data.orderid,
        "checked": Array.isArray(_vm.orderids) ? _vm._i(_vm.orderids, data.orderid) > -1 : (_vm.orderids)
      },
      on: {
        "change": function($event) {
          _vm.resetAll(data)
        },
        "__c": function($event) {
          var $$a = _vm.orderids,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.orderid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.orderids = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.orderids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.orderids = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('td', [(data.btoborder == 1) ? _c('span', {
      staticClass: "btn btn-success",
      staticStyle: {
        "float": "left",
        "padding-left": "-10%"
      },
      attrs: {
        "title": "Assign Multi-Picker"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getmultipicker(data)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('common.multiPicker')) + " ")]) : _vm._e(), _vm._v(" "), (data.btoborder == 1) ? _c('span', {
      staticStyle: {
        "margin-left": "-20%"
      }
    }, [_vm._v(_vm._s(data.orderid))]) : _c('span', {
      staticStyle: {
        "padding-left": "28%"
      }
    }, [_vm._v(_vm._s(data.orderid))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.saleschannel))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddatetime))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalitem))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalquantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ordercode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipbydate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.$t('common.created')))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), (_vm.slaflag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.sladatetime) + " "), _c('br'), _vm._v(" "), (data.slastatus == 'SLA Breached') ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('sla.slabreached')))]) : (data.slastatus == 'Near SLA') ? _c('span', {
      staticClass: "badge badge-warning",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.sladiff / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.sladiff % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : (data.slastatus == 'Within SLA') ? _c('span', {
      staticClass: "badge badge-info",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.sladiff / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.sladiff % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((data.defaultVal == 0 && data.totalquantity == 1) || data.issplited == 1 || data.defaultVal == 1) ? _c('td', {
      staticClass: "text-center"
    }) : _vm._e(), _vm._v(" "), (data.defaultVal == 0 && data.totalquantity > 1 && data.issplited == 0 && _vm.clientid == 1025) ? _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "type": "button",
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          _vm.splitshipment(1, data)
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "reset",
        "disabled": _vm.isLoading
      },
      on: {
        "click": function($event) {
          _vm.splitshipment(0, data)
        }
      }
    }, [_vm._v("No")])]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    staticClass: "confirmation",
    attrs: {
      "size": "lm",
      "title": "Picker Assign"
    },
    model: {
      value: (_vm.pickerAssignmentShow),
      callback: function($$v) {
        _vm.pickerAssignmentShow = $$v
      },
      expression: "pickerAssignmentShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('orders.pickerAssignment')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.pickerAssignmentShow = false;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('orders.orderPicker')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickerid),
      expression: "pickerid"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "name": "pickerid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pickerid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('orders.selectPicker')))]), _vm._v(" "), _vm._l((_vm.pickerListData), function(user_obj) {
    return _c('option', {
      domProps: {
        "value": user_obj.userid
      }
    }, [_vm._v(_vm._s(user_obj.email))])
  })], 2)]), _vm._v(" "), (_vm.pickerid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.SelectPickerErr))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "280px",
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.assignOrderToPicker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow fa-lg"
  }), _vm._v("\n                " + _vm._s(_vm.$t('orders.assign')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.pickerAssignmentShow = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.cancelBtn')) + "\n            ")])])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showlist == 'Multipicker') ? _c('div', [_c('div', [_c('multipickerassign', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-723cbe3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723cbe3c","hasScoped":true}!./src/views/components/pickerAssign/pickerAssign.component.html
// module id = 1645
// module chunks = 0